import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=4b031d6b&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=4b031d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b031d6b",
  null
  
)

export default component.exports